import { defineMessages, FormattedMessage } from "react-intl";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

const messages = defineMessages({
  tooltip: {
    id: "insurance.form.typologySection.tooltip",
    defaultMessage:
      "Si sólo se configura un tramo y se dejan los importe desde y hasta en blanco se aplica sobre cualquier importe de reserva.",
  },
});

export function TooltipComponent() {
  return (
    <OverlayTrigger
      delay={{ show: 250, hide: 0 }}
      placement={"right"}
      overlay={
        <Tooltip id="tooltip">
          <FormattedMessage {...messages.tooltip} />
        </Tooltip>
      }>
      <FontAwesomeIcon icon={faInfoCircle} size="1x" className="ml-2" />
    </OverlayTrigger>
  );
}
